import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_REQUEST } from "../../redux/reducers/loginReducer";

export function Login() {
  const dispatch = useDispatch();
  const session = useSelector((state: any) => state.session);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (session.urlQueryState !== null) {
      dispatch({ type: CREATE_REQUEST, params: { state: session.urlQueryState } });
    }
  }, [dispatch, session.urlQueryState]);

  useEffect(() => {
    if (session.request && formRef.current) {
      formRef.current.submit();
    }
  }, [session.request]);

  return (
    <div className="centered">
      {session.request ? (
        <form ref={formRef} action={session.request.endpoint} method="POST">
          <input
            type="hidden"
            name="client_id"
            value={session.request.authenticationRequest.client_id}
          />
          <input
            type="hidden"
            name="scope"
            value={session.request.authenticationRequest.scope}
          />
          <input
            type="hidden"
            name="response_type"
            value={session.request.authenticationRequest.response_type}
          />
          <input
            type="hidden"
            name="state"
            value={session.request.authenticationRequest.state}
          />
          <input
            type="hidden"
            name="request"
            value={session.request.authenticationRequest.request}
          />
          <input
            type="hidden"
            name="nonce"
            value={session.request.authenticationRequest.nonce}
          />
        </form>
      ) : null}
    </div>
  );
}
